import type { FaireProductEntity } from "../../entity_types/product";

export const p_93vw2qxen5: FaireProductEntity = {
  token: "p_93vw2qxen5",
  type: "product",
  name: "Morning Mist | Yuzu Lemon Rosemary | 8 oz Candle",
  brandToken: "b_ymy9myk6jv",
  brandName: "Kandlery",
  imageUrl:
    "https://cdn.faire.com/fastly/ddb83a1ccd2428fdd0dc682cc9824d05746d8952a537ddb9ce9fe3255c97e618.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2d57523cbc01ef01472499e970e154b1cf55b0d26b9260616db4dea2044eeaa4.png",
    "https://cdn.faire.com/fastly/b09518a1608861c01a48e5fe8b66b166106c04a55a5bc4865129da93dd4e8d49.png",
    "https://cdn.faire.com/fastly/54d77a3f604bbc9569c689aaf7f6fa08f6efc71521d9a9d99820f7a3a803f3c7.png",
    "https://cdn.faire.com/fastly/07d801ec0e2dfa147d3e24a2a0fa0f22bb3c84bfd16defed3ad81ae4fd434703.png",
  ],
  priceDollars: 16,
  description:
    "A blend of crisp lemon, cool mint, aromatic rosemary, calming lavandin, lush jasmine, and robust cedar creates a refreshing ambiance.\n\nNotes of yuzu blossom, lemon, mint, rosemary, lavandin, jasmine and cedar.\n\n𝐒𝐢𝐳𝐞 𝐨𝐩𝐭𝐢𝐨𝐧𝐬:\n• 8 oz. wood wicked iridescent glass jar with a lid\n\nNon-toxic | cruelty-free | pet-friendly\n\nProudly 'Made Better Certified'.\nOur goal is to source supplies with the highest quality standards in mind.\n\n𝐖𝐡𝐲 𝐊𝐚𝐧𝐝𝐥𝐞𝐫𝐲?\n• Natural Coconut Wax\n• Crackling Wooden Wick, Made from FSC Certified Wood.\n• Lead free & Self-trimming Cotton Wick\n• Non Toxic Ingredients\n• Premium Soothing Fragrances (Free of phthalate, reproductive toxins, and other concerning chemicals.)\n• Cruelty Free\n• Handcrafted in Small Batch\n• Untapped Asian-inspired scents",
  tags: [],
  msrpDollars: 32,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-17T20:26:08.134Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
